import { createAsyncThunk } from '@reduxjs/toolkit'
import { ShowException } from 'store/Application/appActions'
import { RootAppState } from 'store/configureStore'
import { projectAPIBuilder } from './BoMAsyncActions'
import { fetchProject } from './fetchProject'
import { newProjectActions } from '../projectReducer'

export const retryFailedImnooEstimates = createAsyncThunk<
  void,
  null,
  { state: RootAppState }
>('project/retryFailedImnooEstimates', async (_args, thunkAPI) => {
  const { api, projectId } = projectAPIBuilder(thunkAPI.getState)
  try {
    await api.RetryFailedImnooEstimates(projectId)
    thunkAPI.dispatch(
      newProjectActions.updateOperationsFlags({
        shallUpdateOperationsSummary: true,
        shallUpdateOperationsLogs: true,
      }),
    )
    await thunkAPI.dispatch(fetchProject({ projectId }))
  } catch (ex) {
    ShowException('project', ex)
    throw ex
  }
})
